"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _UpcomingTasksCard = _interopRequireDefault(require("./UpcomingTasksCard"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _UpcomingTasksCard.default;
exports.default = _default;